module.exports = __webpack_public_path__ + "img/avatar7.d6a858aa.png";